const zh = {
    home: "主页",
    confirm: "确定",
    standardBrain: "标准脑",
    personalBrain: "个体脑",
    motorFunctionMapping: "运动功能图谱",
    languageFunctionMapping: "语言功能图谱",
    fibreBundleMapping: "纤维束图谱",
    dataAndStatistics: "数据与统计",
    electricalPosition: "电刺激定位",
    fibreTrack: "纤维束追踪",
    visitStatistics : "访问统计",
    contactUs : "团队介绍",
    showSurface : "显示皮层",
    pleaseSelectPersonal: "请选择个体",
    sportsArea: "运动区",
    languageArea: "语言区",
    feelArea: "感觉区",
    otherArea: "其他功能区",
    dataDownload: "数据下载",
    pleaseSelectArea: "请选择区域",
    contactFibre: "联络纤维",
    projectFibre: "投射纤维",
    unitedFibre: "联合纤维",
    cerebellum: "小脑",
    speechBreak: "言语中断",
    anepia : "不能言语",
    aphonia : "构音障碍",
    asophia : "发音不清",
    bradyphrasia : "语言缓慢",
    error : "语言错误",
    cannotName: "命名障碍",
    mispronunciation: "构音障碍",
    nameError: "命名错误",
    speechRepetition: "言语重复",
    chineseOnly: "只能中文",
    englishOnly: "只能英语",
    germanOnly: "只能德语",
    japaneseOnly: "只能日语",
    conversionBilingual: "双语转换",
    thumbFinger: "拇指",
    indexFinger: "食指",
    middleFinger: "中指",
    ringFinger: "环指",
    pinky: "小指",
    wrist: "手腕",
    mouth: "嘴",
    throat: "喉咙",
    tongue: "舌",
    teeth: "牙",
    face: "脸",
    palm: "手掌",
    forearm: "前臂",
    eye: "眼",
    foot: "脚",
    knee: "膝盖",
    calf: "小腿",
    abdomen: "腹部",
    shoulder: "肩膀",
    torso: "躯干",
    waist: "腰",
    left: "左",
    right: "右",
    visitStatistic : "访问统计",
    time : "时间",
    all : "全部",
    today : "今天",
    seven : "最近7天",
    month : "最近30天",
    homeDescription: "中国人脑功能图谱数据库及网站，是由北京市神经外科研究所、首都医科大学附属北京天坛医院和北京脑科学与类脑研究中心\n" +
        "        联合开展的共建项目。该数据库可分为标准脑空间和个体脑空间下的脑功能图谱两个主要部分，\n" +
        "        主要基于真实患者皮层和皮层下功能区定位数据（通过唤醒手术下直接电刺激技术获得）构建而成，\n" +
        "        记录了在标准空间和个体空间下每个手指不同运动形式、感觉及不同语言功能相关的皮层分布情况。\n" +
        "        其中，标准空间脑功能图谱的绘制共使用了30000余个阴性刺激点和3000余个阳性刺激点的数据。\n" +
        "        在此基础上，项目团队经统计进一步获得了精确到每个手指的毫米级感觉运动功能标准空间皮层分布图，\n" +
        "        以及语言精细功能标准空间皮层分布图。该数据库为前瞻性采集数据库，定期更新，\n" +
        "        目前已收录200余例唤醒手术术中电刺激功能区定位数据及对应的术前多模态影像学资料（去颅骨）和临床神经功能资料，\n" +
        "        旨在为脑科学研究提供全面、丰富的大样本数据集资源。",




    Association : "联络纤维",
    ArcuateFasciculus : "弓状束",
    ArcuateFasciculusExplain : "在豆状核与岛叶上方围绕岛叶区走行，与上纵束平行，联络额、顶、枕、颞四个叶。可分为直接通路和间接通路。",
    ArcuateFasciculusFunction : "直接通路主要连接Broca区和Wernicke区，与语音功能有关；间接通路可分为两部分：前部主要连接额部和顶部的皮层，与语义内容的发音有关；后部主要连接颞部和顶部皮层，与词汇-语义之间的运转有关。弓状束的损伤与传导性失语相关。",
    FrontalParahippocampalCingulum : "额部海马旁扣带",
    CingulumExplain: "扣带位于大脑半球内侧面，沿着扣带回的弯曲构成大部分扣带回内白质。包括长、短两种联络纤维，沿扣带回和胼胝体的弯曲走行，它连接胼胝体前部下方的胼胝体下区和嗅旁区、胼胝体上方的扣带回、位于胼胝体后部和下方的扣带回峡部和海马旁回。",
    CingulumFunction: "扣带回投射至颞叶内侧的白质纤维的集合，是边缘系统的PAPEZ环路重要组成部分，与执行、决策和情感情绪过程有关。损伤可能意志力下降、情绪低沉等。",
    FrontalParietalCingulum: "额顶部扣带",
    ParahippocampalParietalCingulum: "顶部海马旁扣带",
    ParahippocampalCingulum: "海马旁扣带",
    ParolfactoryCingulum: "嗅旁扣带",
    ExtremeCapsule: "最外囊",
    ExtremeCapsuleExplain: "紧贴岛叶皮层下的不规则薄层白质结构，位于岛叶皮层与屏状核之间，主要连接岛叶各脑回皮层灰质，同时其纤维向岛盖延续，连接岛叶皮层与额下回、颞上回。",
    ExtremeCapsuleFunction: "连接岛叶不同脑回的灰质皮层，参与语言的理解，损伤可能导致语言系统功能受损。",
    FrontalAslantTract:"额斜束",
    FrontalAslantTractExplain:"连接额下回盖部至前扣带皮层以及额上回内侧部分，如辅助运动前区和扣带前区。",
    FrontalAslantTractFunction:"与语言的流畅性有关。",
    InferiorFrontoOccipitalFasciculus : "下额枕束",
    InferiorFrontoOccipitalFasciculusExplain : "起自枕中回、枕下回和楔前叶，穿过颞上回和颞中回，至颞角和侧脑室房部的下三分之二。",
    InferiorFrontoOccipitalFasciculusFunction : "在视觉刺激的语义处理、多感官输入的整合、阅读、写作、理解和有意义的言语产生中存在作用。",
    InferiorLongitudinalFasciculus: "下纵束",
    InferiorLongitudinalFasciculusExplain: "下纵束起自枕叶背外侧皮质，连接至颞枕叶及边缘叶等。",
    InferiorLongitudinalFasciculusFunction: "可能在阅读和视觉信息形成中起作用，损伤可能导致失读症。",
    MiddleLongitudinalFasciculus: "中纵束",
    MiddleLongitudinalFasciculusExplain: "起源于楔叶和顶上小叶，在胼胝体压部下方，终止于颞极背外侧和颞上回。",
    MiddleLongitudinalFasciculusFunction: "协同弓状束功能，可能参与视听觉信息的整合。",
    ParietalAslantTract: "顶斜束",
    ParietalAslantTractExplain: "起源于外侧颞叶，终止于顶上小叶的联络纤维。",
    ParietalAslantTractFunction: "连接颞叶外侧与顶上小叶，可能与识别声音或单词的意思有关。",
    SuperiorLongitudinalFasciculus1 : "上纵束 I",
    SuperiorLongitudinalFasciculus1Explain : "在额上回内沿弓状束方向走行，与顶上小叶有连接，并通过扣带束上方和胼胝体内侧到额叶和前扣带皮层。",
    SuperiorLongitudinalFasciculus1Function : "可能与以身体为中心的高级动作的控制有关。",
    SuperiorLongitudinalFasciculus2: "上纵束 II",
    SuperiorLongitudinalFasciculus2Explain: "位于额中回内，与上纵束I平行走行，连接枕叶及角回至背侧运动前皮质区及外侧额叶皮层。",
    SuperiorLongitudinalFasciculus2Function: "可能与对视觉空间不同区域的注意调节有关。",
    SuperiorLongitudinalFasciculus3: "上纵束 III",
    SuperiorLongitudinalFasciculus3Explain: "与其他上纵束走行类似，但多在额顶叶下内侧、AF的外侧，连接缘上回至额下回盖部。",
    SuperiorLongitudinalFasciculus3Function: "与语音的记忆、发音有关，损伤与构音障碍有关。",
    UncinateFasciculus : "钩束",
    UncinateFasciculusExplain : "位于前穿质的外缘，岛叶前下部的边缘，经过岛阈，在外侧裂的蝶部和岛盖部连接处形成隆起，围绕外侧裂干连接额叶和颞叶。",
    UncinateFasciculusFunction : "在多种语义处理中发挥作用，参与一般性认知控制功能，可能与边缘系统作用类似，在情感、情景记忆、语义语言等方面存在作用。",
    VerticalOccipitalFasciculus: "垂直枕束",
    VerticalOccipitalFasciculusExplain: "位于侧脑室房部后三分之一外侧，弓状束后方，斜向垂直连接枕下叶至枕上叶外侧和角回。",
    VerticalOccipitalFasciculusFunction: "损伤后可能与失读症有关。",

    Projection : "投射纤维",
    AcousticRadiation: "听辐射",
    AcousticRadiationExplain: "接收来自内侧膝状体的神经元发出的轴突，投射至大脑颞横回皮质。",
    AcousticRadiationFunction: "传导听觉信息。",
    CorticobulbarTract : "皮质延髓束",
    CorticobulbarTractExplain : "中央前回下部等处皮质中的锥体细胞的轴突集合成，经内囊膝，下行至中脑，走在大脑脚底中间3／5的内侧部。此后，陆续分出一部分纤维，终止于脑干内两侧的躯体运动核和特殊内脏运动核，包括动眼神经核、滑车神经核、三叉神经运动核、展神经核、面神经核(支配眼裂以上面肌的细胞)、疑核和副神经核。",
    CorticobulbarTractFunction : "负责支配脑干内脑神经运动核、网状结构以及其他脑干运动相关核团。",
    FrontalCorticopontineTract : "额桥束/额脑桥束",
    FrontalCorticopontineTractExplain : "源于大脑皮质锥体细胞的传导束。包括额桥束和顶枕颞桥束，经内囊和中脑腹侧的大脑脚底下行，终于脑桥核。额桥束占皮质脑桥纤维的55%，它们通过内囊的前肢、膝部和后肢。顶桥束主要通过内囊的豆状核后部，一些纤维穿过内囊豆状核下部。枕桥束穿过内囊的豆状核后部。",
    FrontalCorticopontineTractFunction : "各自接收来自皮质的信息，经脑桥核发出信息调控小脑功能。",
    ParietalCorticopontineTract: "顶桥束/顶脑桥束",
    OccipitalCorticopontineTract: "枕桥束/枕脑桥束",
    AnteriorCorticostriatalTract : "皮质纹状体前束",
    AnteriorCorticostriatalTractExplain : "大脑额叶、顶叶、枕叶、颞叶皮质细胞发出的纤维，直接地或通过背侧丘脑间接地终止于尾状核和豆状核壳核。",
    AnteriorCorticostriatalTractFunction : "可能参与调节肌张力、协调肌的运动、维持体态姿势、担负半自动的刻板运动和反射性运动等。",
    SuperiorCorticostriatalTract : "皮质纹状体上束",
    PosteriorCorticostriatalTract : "皮质纹状体后束",
    CorticoSpinalTract : "皮质脊髓束",
    CorticoSpinalTractExplain : "皮质脊髓束位于大脑脚底中部1/3，在脑桥被脑桥核分割成许多小束，在延髓又合而为一成椎体。在延髓最下端，大部分纤维交叉至对侧，成为皮质脊髓侧束，小部分未交叉，成为皮质脊髓前束。",
    CorticoSpinalTractFunction : "皮质脊髓侧束直接投射到位于脊髓前角外侧，控制手和手指精细运动的下运动神经元；皮质脊髓前束到达运动核支配肢体近端肌和躯干肌的随意运动。",
    DentatorubrothalamicTract: "齿状红核丘脑束",
    DentatorubrothalamicTractExplain: "由小脑齿状核发出，经小脑脚上部至对侧红核，止于丘脑腹外侧核的神经束。",
    DentatorubrothalamicTractFunction: "可能在认知功能中发挥着重要作用，如计划、语言流畅性、工作记忆、抽象思维和行为。",
    Fornix : "穹隆",
    FornixExplain : "穹窿由投射纤维、连合纤维和联络纤维组成，起自海马。穹窿中的投射纤维连接到下丘脑的乳头体的神经元。穹窿连合纤维在胼胝体压部的下方与对侧穹窿交叉，终止于对侧海马。穹窿内的联络纤维连接海马与邻近的海马旁回和隔区。",
    FornixFunction : "在认知和情景记忆中起着关键作用, 损伤可能导致认知缺陷、失忆。",
    MedialLemniscus : "内侧丘系",
    MedialLemniscusExplain : "位于脑干中线两侧的纤维束，源于薄束核与楔束核经丘系交叉后的上行纤维束。",
    MedialLemniscusFunction : "传递躯干和四肢意识性本体感觉和精细触压觉。",
    OpticRadiation : "视辐射",
    OpticRadiationExplain : "外侧膝状体发出的纤维，经过内囊的豆核后部，投射至楔叶和舌回。",
    OpticRadiationFunction : "传导视觉信息。",
    ReticulospinalTract: "网状脊髓束",
    ReticulospinalTractExplain: "行于同侧白质前索和外侧索前内侧部，起自脑桥和延髓的网状结构，止于板层VII、VIII的传导束。",
    ReticulospinalTractFunction: "调节肢体近端关节运动、维持姿势及调节肌张力等。",
    AnteriorThalamicRadiation : "丘脑前辐射",
    AnteriorThalamicRadiationExplain : "通过内囊前肢联系于丘脑背内侧核与前额、眶区以及丘脑前核与扣带回之间的向大脑皮质的投射。",
    AnteriorThalamicRadiationFunction : "参与语音语义的处理过程，可能与情感情绪的传导有关。",
    PosteriorThalamicRadiation: "丘脑后辐射",
    PosteriorThalamicRadiationExplain: "丘脑至枕叶的纤维，包括从外侧膝状体到视觉皮层的视辐射，位于内囊的豆状核后部。",
    PosteriorThalamicRadiationFunction: "传导视觉感觉。",
    SuperiorThalamicRadiation : "丘脑上辐射",
    SuperiorThalamicRadiationExplain : "从丘脑腹侧核群（腹前部、腹外侧、腹后内侧和腹后外侧）到躯体运动区和躯体感觉区的纤维构成丘脑上部辐射。",
    SuperiorThalamicRadiationFunction : "负责将躯体感觉传送到大脑皮层。",

    Commissural : "连合纤维",
    AnteriorCommissure : "前连合",
    AnteriorCommissureExplain : "在穹隆柱前方跨越中线的纤维束，构成第三脑室的前壁，连接两侧嗅结构和颞叶脑回。",
    AnteriorCommissureFunction : "前连合主要连接两个半球的颞叶。不过其中也包含嗅束的交叉纤维。前连合也是新脊髓丘脑束的一部分，与痛觉相关。除此之外，前连合还连接两侧的杏仁体。",
    CorpusCallosum : "胼胝体",
    CorpusCallosumExplain : "是联络左右大脑半球的纤维构成的纤维束板。在大脑正中矢状切面上，胼胝体呈弓状，前端接终板处称胼胝体嘴，弯曲部称胼胝体膝，中部称胼胝体干，后部称胼胝体压部。",
    CorpusCallosumFunction : "1、传递大脑半球间的视觉运动信息34,35；\n" +
        "2、胼胝体的中前部连接前运动皮层和顶叶皮层，转移空间注意从而影响感觉运动的整合34；\n" +
        "3、胼胝体后部在视觉感受区和视觉运动整合结构之间传递信息；\n" +
        "4、双侧大脑半球的颞顶联合区通过胼胝体传达视觉运动整合与注意力机制的共活化作用36；\n" +
        "5、胼胝体压部的后部区域与局部-整体视觉的整合有关37；\n" +
        "6、双侧前辅助运动区通过胼胝体进行实践信息的交流。",


    Cerebellum : "小脑",
    InferiorCerebellarPeduncle : "小脑下脚",
    InferiorCerebellarPeduncleExplain : "又称绳状体，位于延髓背侧面的楔束结节外上方，构成菱形窝下外侧界，由进入小脑的脊髓小脑后束、前庭小脑束及橄榄小脑束等多种纤维构成。",
    InferiorCerebellarPeduncleFunction : "传导小脑和延髓、脊髓之间的纤维束。脊髓小脑后束传输大部分身体的本体感觉，是小脑下脚的主要神经束。",
    MiddleCerebellarPeduncle:"小脑中脚",
    MiddleCerebellarPeduncleExplain:"又称绳状体，位于延髓背侧面的楔束结节外上方，构成菱形窝下外侧界，由进入小脑的脊髓小脑后束、前庭小脑束及橄榄小脑束等多种纤维构成。",
    MiddleCerebellarPeduncleFunction:"皮质-脑桥系统的大量纤维终止于脑桥核，通过小脑中脚进行突触联系和交叉，然后投射到新小脑，为小脑提供了皮质信息的相关运动指令和计划。",
    SuperiorCerebellarPeduncle: "小脑上脚",
    SuperiorCerebellarPeduncleExplain: "又称结合臂，连于小脑和中脑之间，主要成分为起自小脑中央核，止于对侧红核和背侧丘脑的小脑传出纤维，传入纤维主要有脊髓小脑前束、三叉小脑束等。",
    SuperiorCerebellarPeduncleFunction: "承受来自小脑的主要传出通路，参与运动调节系统。",
    Vermis : "小脑蚓部",
    VermisExplain : "位于两小脑半球之间的狭窄部，分为蚓结节、蚓椎体、蚓垂和小结等部。",
    VermisFunction : "调节肌张力、维持躯体的平衡、协调运动。",

    CranialNerves : "颅神经",
    CNII : "视神经",
    CNIIExplain : "由视网膜节细胞的轴突组成，穿过颅骨的视神经孔入颅后，与对侧来的纤维合在一起成为视交叉，交叉后的纤维组成视束，其终末止于丘脑枕部的外侧膝状体、顶盖前区。",
    CNIIFunction : "传导视觉信息的视觉传导通路。",
    CNIII : "动眼神经",
    CNIIIExplain : "起自中脑上丘水平的动眼神经核和动眼神经副核，经大脑脚内面的动眼神经沟出脑，向前穿过海绵窦的侧壁，在此处分为上下支穿过眶上裂入眶，在总腱环内位于视神经外侧。",
    CNIIIFunction : "支配除上斜肌和外直肌以外的眼肌。",
    CNV : "三叉神经",
    CNVExplain : "在脑干表面位于脑桥中部的腹外侧面，由大的感觉根和小的运动根组成。三叉神经的感觉纤维发自半月神经节内的假单极细胞，其中枢突聚成三叉神经感觉根，自颞骨岩部向后内方走行入脑桥，终止于脑干内三叉神经感觉主核和三叉神经脊束核，其周缘突形成三个干支：眼神经、上颌神经和下颌神经。三叉神经运动根较细，发自脑桥中部的三叉神经运动核，在脑干表面位于感觉根内侧稍前方，行走于半月神经节的下方，在卵圆孔处与三叉神经的下颌支合并，一起穿卵圆孔出颅，分布至咀嚼肌、翼内肌和翼外肌等面部肌肉。",
    CNVFunction : "三叉神经主要司头面部皮肤黏膜的痛觉、温度觉和触觉的传导，并支配咀嚼肌、翼内肌、翼外肌和鼓膜张肌等面部肌肉。",
    CNVII: "面神经",
    CNVIIExplain: "属混合神经，由感觉根和运动根组成。在脑干表面，面神经位于脑桥下方小脑下脚与橄榄之间的隐窝处，面神经的运动跟居内侧，感觉根居中间，外侧为位听神经。运动纤维发自脑桥被盖部的面神经核，经内耳孔入颞骨岩部，走行在面神经管内，自茎乳孔出颅，进入腮腺实质内，在此分成颞支、颧支、颊支、下颌缘支和颈支。感觉纤维有三个来源：起自膝状神经节细胞的周缘支，通过鼓索及舌神经，分布于舌前2/3的味蕾，其中枢突止于孤束核；起自膝状神经节的周缘支，通过面神经与面部的深感觉有关，中枢突也止于孤束核；起自脑桥泌涎核的纤维，通过鼓索及舌神经到下颌神经节。",
    CNVIIFunction: "支配面部的表情肌、颊肌、头皮和外耳的肌肉、颈阔肌、二腹肌后腹、茎突舌骨肌及镫骨肌，司舌前2/3的味觉，支配颌下腺和舌下腺。",
    CNVIII: "位听神经",
    CNVIIIExplain: "由耳蜗神经和前庭神经两部分组成，在脑干表面位于面神经外侧，经内耳门出颅。耳蜗神经的纤维发自耳蜗螺旋神经节的双极细胞，其周缘突止于戈蒂氏螺旋器，中枢突止于脑干的耳蜗背核和耳蜗腹核。前庭神经发自内耳道中的前庭神经节之双极细胞，周缘突行向半规管、椭圆囊及球囊，中枢突入脑干，止于前庭上核、前庭内侧核、前庭外侧核以及前庭下核，也有纤维终止于小脑绒球小结叶。",
    CNVIIIFunction: "传导听觉和位置觉。",
    downloadTip: "数据下载请联系{email}",
    anatomyExplained : "解剖解释",
    function: "功能",
}
export default zh;